import { OTA_POS } from "./ota_pos.model";
import { OTA_VehCancelRQCore } from "./ota_vehcancelrqcore.model";

export class OTA_VehCancelRQ {
    public pos = new OTA_POS();
    public vehCancelRQCore = new OTA_VehCancelRQCore();
}